<template>
  <div class="msg-bell-msg-view">
    <div class="main-content">
      <div class="app-main-inner-row" style="padding-top: 10px;">
        <div class="triggers">
          <span>{{ $t('CargoMsg.Cargo_Search') }}</span>
          <el-input
            v-model="keyword"
            :placeholder="$t('common.tips.fuzzySearch')"
            style="width:200px;margin: 0 10px"
            @input="fastSearchHandle()"
          />
          <el-button type="primary" @click="btnAdd">{{ $t('common.btn.new') }}</el-button>
          <el-button type="primary" @click="btnEdit">{{ $t('common.btn.edit') }}</el-button>
          <el-button size="mini" type="danger" @click="btnRemoveHandler">{{ $t('common.btn.delete') }}</el-button>
        </div>
      </div>
      <div class="section grid-wrapper" style="flex-grow: 1;">
        <cargo-ag-grid
          :column-defs="columnDefs"
          :row-data="rowData"
          :grid-options="gridOptions"
          :side-bar="sideBarDefs"
          style="width: 100%;"
        />
      </div>
      <div class="pagination-wrapper">
        <cargo-pagination
          config-module="202405282006"
          :total="pageInfo.total"
          :page.sync="pageInfo.pageNum"
          :limit.sync="pageInfo.pageSize"
          @pagination="loadData"
        />
      </div>
    </div>
    <el-dialog
      slot="reference"
      v-el-drag-dialog
      :close-on-click-modal="false"
      class="dialog"
      :visible.sync="showEditDialog"
      :title="title"
      width="430px"
      @closed="cancelHandler"
      @open="getClassifyMsg"
    >
      <!-- 循环处理 -->
      <el-tabs
        v-model="activeName"
        tab-position="top"
        class="dialog-tabs"
      >
        <el-tab-pane v-for="(item) in form" :label="item.name" :name="item.name">
          <el-form
            :model="item"
            label-width="100px"
            class="dialog-tabs-form"
            size="medium"
          >
            <el-form-item :label="$t('SystemMaintenance.ClassifyName')">
              <el-select v-model="item.classifyUuid" style="width: 250px" :disabled="item.language!=='zh_CN'" @change="changeSyncClassify(item)">
                <el-option
                  v-for="(item,index) in selectClassifyMsgList"
                  :key="index"
                  :label="item.classifyName"
                  :value="item.uuid"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('SystemMaintenance.MsgTitle')">
              <el-input v-model="item.title" class="required-star" />
            </el-form-item>
            <el-form-item :label="$t('SystemMaintenance.Code')">
              <el-input v-model="item.code" :disabled="item.language!=='zh_CN'" class="required-star" @change="changeSyncCode(item)" />
            </el-form-item>
            <el-form-item :label="$t('SystemMaintenance.Content')">
              <el-input v-model="item.content" class="required-star" type="textarea" />
            </el-form-item>
            <el-form-item :label="$t('SystemMaintenance.Link')">
              <el-input v-model="item.link" :disabled="item.language!=='zh_CN'" style="width: 250px;" @change="changeSyncLink(item)" />
              <el-tooltip class="item" effect="light" :content="$t('SystemMaintenance.LinkTip')" placement="top-end">
                <i class="el-icon-warning" style=" font-size:15px; color: #DCA550; margin: 0 5px;" />
              </el-tooltip>
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
      <div slot="footer">
        <el-button size="mini " type="primary" @click="submitHandler">{{ $t('common.btn.save') }}</el-button>
        <el-button size="mini " @click="cancelHandler">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import * as bellMsgApi from '@/api/sysManage/sysMsgConfig/bellMsg'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { getLoading } from '@/utils/utilBaseElement'
import { getClassifyMsg } from '@/api/sysManage/sysMsgConfig/msgClassifyManager'
import * as LanguageConstant from '@/class/cargo/model/parameters/LanguageConstant'
import { pageBellMsg } from '@/api/sysManage/sysMsgConfig/bellMsg'

export default {
  name: 'BellMsgView',
  components: {
    cargoAdvanceSelect
  },
  data() {
    return {
      keyword: '',
      columnDefs: [
        {
          headerName: this.$t('SystemMaintenance.ClassifyName'),
          field: 'classifyName',
          width: 250
        }, {
          headerName: this.$t('SystemMaintenance.MsgTitle'),
          field: 'title',
          width: 250
        }, {
          headerName: this.$t('SystemMaintenance.Code'),
          field: 'code',
          width: 250
        },
        {
          headerName: this.$t('SystemMaintenance.Content'),
          field: 'content',
          width: 250
        },
        {
          headerName: this.$t('SystemMaintenance.Link'),
          field: 'link',
          width: 250
        },
        {
          headerName: this.$t('SystemMaintenance.Language'),
          field: 'language',
          valueFormatter: params => {
            return LanguageConstant.getLanguageByCode(params.value).chineseName
          }
        }
      ],
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      rowData: [],
      originalRowData: [],
      gridOptions: {},
      showEditDialog: false,
      title: '',
      activeName: this.$t('Tool.Chinese'),
      classifyMsgList: [],
      selectClassifyMsgList: [],
      pageInfo: {
        total: 0,
        pageNum: 1,
        pageSize: 20
      },
      form: [
        {
          name: this.$t('Tool.Chinese'),
          language: LanguageConstant.ZH_CN.code,
          uuid: '',
          classifyUuid: '',
          code: '',
          title: '',
          content: '',
          link: ''
        },
        {
          name: this.$t('Tool.English'),
          language: LanguageConstant.EN_US.code,
          uuid: '',
          classifyUuid: '',
          code: '',
          title: '',
          content: '',
          link: ''
        },
        {
          name: this.$t('Tool.Japanese'),
          language: LanguageConstant.JA_JP.code,
          uuid: '',
          classifyUuid: '',
          code: '',
          title: '',
          content: '',
          link: ''
        }
      ]
    }
  },
  watch: {
    'activeName': function() {
      this.filterClassifyMsgHandle()
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    // 初始化加载
    loadData() {
      const loading = getLoading()
      // 定义分页参数
      bellMsgApi.pageBellMsg(this.pageInfo).then(resp => {
        if (resp.data) {
          this.pageInfo.total = Number(resp.data.total)
          this.pageInfo.pageNum = resp.data.pageNum
          this.pageInfo.pageSize = resp.data.pageSize
          this.rowData = resp.data.list
          this.originalRowData = resp.data.list
          this.fastSearchHandle()
        }
      }).finally(() => loading.close())
    },
    // 模糊检索内部数据
    fastSearchHandle() {
      // keyword有内容时
      if (this.keyword) {
        this.rowData = this.rowData.filter(p =>
          (p.classifyName && p.classifyName.toLowerCase().includes(this.keyword.toLowerCase())) ||
          (p.title && p.title.toLowerCase().includes(this.keyword.toLowerCase())) ||
          (p.code && p.code.toLowerCase().includes(this.keyword.toLowerCase())) ||
          (p.content && p.content.toLowerCase().includes(this.keyword.toLowerCase()))
        )
      } else {
        // 没有内容就赋原始值
        this.rowData = this.originalRowData
      }
    },
    // 填充其他语言的信息
    fillDefaultInfo() {
      // 找到中文的信息
      const zhCnInfo = this.form.find(v => v.language === LanguageConstant.ZH_CN.code)
      // 英文或者日文内容为空 就填充中文的信息
      this.form.forEach(v => {
        if (v.language !== LanguageConstant.ZH_CN.code) {
          // v的属性为空就赋值为zhCnInfo的属性
          for (const key in v) {
            // 对应的语言版本要使用对应语言版本的classifyUuid
            if (key === 'classifyUuid') {
              // 先赋值中文分类的uuid
              v[key] = zhCnInfo[key]
              // 找到中文对应的中文分类信息
              const classifyInfoZhCN = this.classifyMsgList.find(v => v.uuid === zhCnInfo.classifyUuid)
              if (classifyInfoZhCN) {
                // 通过中文分类信息的code找到全部的语言版本
                const classifyInfoArr = this.classifyMsgList.filter(v => v.code === classifyInfoZhCN.code)
                if (classifyInfoArr) {
                  if (v.language === LanguageConstant.EN_US.code) {
                    const classifyMsgEnUS = classifyInfoArr.find(v => v.language === LanguageConstant.EN_US.code)
                    if (classifyMsgEnUS) {
                      v[key] = classifyMsgEnUS.uuid
                    }
                  } else if (v.language === LanguageConstant.JA_JP.code) {
                    const classifyMsgJaJP = classifyInfoArr.find(v => v.language === LanguageConstant.JA_JP.code)
                    if (classifyMsgJaJP) {
                      v[key] = classifyMsgJaJP.uuid
                    }
                  }
                }
              }
            }
            // 其他字段赋值
            if (key !== 'language' || key !== 'name' || key !== 'classifyUuid') {
              v[key] = v[key] || zhCnInfo[key]
            }
          }
        }
      })
    },
    // 新增按钮
    btnAdd() {
      this.title = this.$t('CargoMsg.Cargo_Add')
      this.showEditDialog = true
    },
    // 编辑按钮
    btnEdit() {
      const cell = this.gridOptions.api.getFocusedCell()
      const nodes = this.gridOptions.api.rowModel.rowsToDisplay
      const selectedRow = (cell && nodes.length > 0) ? nodes.find(node => node.rowIndex === cell.rowIndex).data : null
      if (!selectedRow) {
        this.$message.warning(this.$t('Message.PleaseSelectDataBeforeOperation'))
        return
      }
      // 选择数据后将对应的数据绑定到form中
      const filter = this.rowData.filter(v => v.code === selectedRow.code)
      // 处理选中后的优选显示标签
      this.activeName = selectedRow.language === LanguageConstant.ZH_CN.code ? this.$t('Tool.Chinese') : selectedRow.language === LanguageConstant.EN_US.code ? this.$t('Tool.English') : selectedRow.language === LanguageConstant.JA_JP.code ? this.$t('Tool.Japanese') : ''
      filter.forEach(v => {
        const formData = this.form.find(val => val.language === v.language)
        if (formData) {
          // 这里我们复制除了code以外的所有属性
          Object.keys(formData).forEach(key => {
            if (key !== 'language' && key !== 'name') {
              formData[key] = v[key]
            }
          })
        }
      })
      this.title = this.$t('CargoMsg.Cargo_Edit')
      this.showEditDialog = true
    },
    // 删除按钮处理
    btnRemoveHandler() {
      const cell = this.gridOptions.api.getFocusedCell()
      const nodes = this.gridOptions.api.rowModel.rowsToDisplay
      const node = (cell && nodes.length > 0) ? nodes.find(node => node.rowIndex === cell.rowIndex) : null
      if (!node || !node.data) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectDataToDelete'))
        return
      }
      this.$confirm(this.$t('SystemMaintenance.ConfirmDeletionOfBellMsg'), this.$t('common.tips.confirm'), {
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        const loading = getLoading()
        // 调用删除接口
        bellMsgApi.removeBellMsg([node.data.code]).then(resp => {
          const res = resp.data
          if (res > 0) {
            this.$message.success(this.$t('CargoMsg.Cargo_OperationSuccessfully'))
            this.loadData()
          } else {
            this.$message.warning(this.$t('SeaExport.OperationFailed'))
          }
        }).finally(() => loading.close())
      })
    },
    submitHandler() {
      if (this.title === this.$t('CargoMsg.Cargo_Edit')) {
        this.updateHandle()
      } else if (this.title === this.$t('CargoMsg.Cargo_Add')) {
        this.addHandle()
      }
    },
    cancelHandler() {
      this.showEditDialog = false
      this.form = [
        {
          name: this.$t('Tool.Chinese'),
          language: LanguageConstant.ZH_CN.code,
          uuid: '',
          classifyUuid: '',
          code: '',
          title: '',
          content: '',
          link: ''
        },
        {
          name: this.$t('Tool.English'),
          language: LanguageConstant.EN_US.code,
          uuid: '',
          classifyUuid: '',
          code: '',
          title: '',
          content: '',
          link: ''
        },
        {
          name: this.$t('Tool.Japanese'),
          language: LanguageConstant.JA_JP.code,
          uuid: '',
          classifyUuid: '',
          code: '',
          title: '',
          content: '',
          link: ''
        }
      ]
      this.activeName = this.$t('Tool.Chinese')
      this.classifyMsgList = []
      this.selectClassifyMsgList = []
    },
    // 查询所有的分类消息
    async getClassifyMsg() {
      await getClassifyMsg().then(resp => {
        if (resp && resp.data) {
          this.classifyMsgList = resp.data.sort((a, b) => a.sort - b.sort)
          // 默认给中文的筛选，有watch监听activeName进行修改
          this.filterClassifyMsgHandle()
        }
      })
    },
    // 同步分类
    changeSyncClassify(fromCnInfo) {
      // 找到中文的信息
      if (fromCnInfo && fromCnInfo.classifyUuid) {
        // 找到中文的分类信息
        const classifyInfoZhCN = this.classifyMsgList.find(v => v.uuid === fromCnInfo.classifyUuid)
        if (classifyInfoZhCN) {
          [LanguageConstant.JA_JP.code, LanguageConstant.EN_US.code].forEach(v => {
            // 找到对应的语言的分类信息
            const languageInfo = this.classifyMsgList.find(classify => classify.code === classifyInfoZhCN.code && classify.language === v)
            if (languageInfo) {
              // 将信息赋值给对应的信息
              this.form.forEach(val => {
                if (v === val.language) {
                  val.classifyUuid = languageInfo.uuid
                }
              })
            }
          })
        }
      } else {
        // eslint-disable-next-line no-return-assign
        this.form.every(v => v.classifyUuid = '')
      }
    },
    // 同步code
    changeSyncCode(obj) {
      // eslint-disable-next-line no-return-assign
      this.form.forEach(v => v.code = obj.code)
    },
    // 同步link
    changeSyncLink(obj) {
      // eslint-disable-next-line no-return-assign
      this.form.forEach(v => v.link = obj.link)
    },
    filterClassifyMsgHandle() {
      if (this.classifyMsgList) {
        if (this.activeName === this.$t('Tool.Chinese')) {
          this.selectClassifyMsgList = this.classifyMsgList.filter(v => v.language === LanguageConstant.ZH_CN.code)
        } else if (this.activeName === this.$t('Tool.English')) {
          this.selectClassifyMsgList = this.classifyMsgList.filter(v => v.language === LanguageConstant.EN_US.code)
        } else if (this.activeName === this.$t('Tool.Japanese')) {
          this.selectClassifyMsgList = this.classifyMsgList.filter(v => v.language === LanguageConstant.JA_JP.code)
        }
      }
    },
    checkPramHandle() {
      // 修改时uuid不可为空
      if (this.title === this.$t('CargoMsg.Cargo_Edit') && this.form.some(v => !v.uuid)) {
        return false
      }
      // 分类消息不可为空
      if (this.form.some(v => !v.classifyUuid)) {
        this.$message.warning(this.$t('SystemMaintenance.ClassifyMsgNameEmpty'))
        return false
      }
      // 消息标题不可为空
      if (this.form.some(v => !v.title)) {
        this.$message.warning(this.$t('SystemMaintenance.BellMsgTitleEmpty'))
        return false
      }
      // 代码不可为空
      if (this.form.some(v => !v.code)) {
        this.$message.warning(this.$t('SystemMaintenance.BellMsgCodeEmpty'))
        return false
      }
      // 正文不可为空
      if (this.form.some(v => !v.content)) {
        this.$message.warning(this.$t('SystemMaintenance.BellMsgContentEmpty'))
        return false
      }
      return true
    },
    // 新增
    addHandle() {
      // 校验数据
      if (!this.checkPramHandle()) {
        return
      }
      // 调用新增接口
      const loading = getLoading()
      bellMsgApi.addBellMsg(this.form).then(resp => {
        if (resp && resp.data && resp.data > 0) {
          this.$message.success(this.$t('CargoMsg.Cargo_OperationSuccessfully'))
          this.cancelHandler()
          this.loadData()
        } else {
          this.$message.warning(this.$t('SeaExport.OperationFailed'))
        }
      }).finally(() => loading.close())
    },
    // 修改
    updateHandle() {
      // 校验数据
      if (!this.checkPramHandle()) {
        return
      }
      // 调用修改接口
      const loading = getLoading()
      bellMsgApi.updateBellMsg(this.form).then(resp => {
        if (resp && resp.data && resp.data > 0) {
          this.$message.success(this.$t('CargoMsg.Cargo_OperationSuccessfully'))
          this.cancelHandler()
          this.loadData()
        } else {
          this.$message.warning(this.$t('SeaExport.OperationFailed'))
        }
      }).finally(() => loading.close())
    }
  }
}
</script>

<style lang="scss" scoped>
.msg-bell-msg-view {
  .required-star {
    position: relative;
    width: 250px;

    &::after {
      content: "*";
      color: red;
      font-size: 20px;
      position: absolute;
      top: 65%;
      right: -15px;
      transform: translateY(-50%);
    }
  }
}
</style>
<!-- 因为scoped只对当前组件生效 权限问题-->
<style lang="scss">
.msg-bell-msg-view {
  .el-tabs__active-bar {
    display: none !important;
  }
  .el-tabs__nav-wrap::after{
    height: 1px;
  }

  .dialog-tabs {
    height: 300px;

    .dialog-tabs-form {
      margin-top: 20px;
    }

    .el-tabs__item {
      margin-left: 0 !important;
      background-color: #F3F4F5 !important;
      border-radius: 0 !important;
    }
    .el-tabs__item.is-active {
      background-color: #3A73CE !important;
    }
  }
}
</style>
